import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Info } from 'lucide-react';

/**
 * Facts behind an info icon: a label/value list that opens on hover or
 * focus. `facts` is [[label, value], …]; empty values are dropped and the
 * icon renders nothing when fewer than `min` facts remain.
 */
export default function FactsPopover({ id, label, facts, min = 1, children }) {
    const rows = (facts || []).filter(([, value]) => value !== null && value !== undefined && value !== '');
    if (rows.length < min) return null;
    return (
        <OverlayTrigger
            placement="bottom-end"
            trigger={['hover', 'focus']}
            overlay={(
                <Popover id={id} style={{ maxWidth: 360 }}>
                    <Popover.Body style={{ padding: '10px 12px' }}>
                        <dl style={{ margin: 0, fontSize: '0.75rem', color: '#374151', display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: '3px 12px' }}>
                            {rows.map(([factLabel, value]) => (
                                <React.Fragment key={factLabel}>
                                    <dt style={{ fontWeight: 500, color: '#6b7280', whiteSpace: 'nowrap' }}>{factLabel}</dt>
                                    <dd style={{ margin: 0, overflowWrap: 'anywhere', fontVariantNumeric: 'tabular-nums' }}>{value}</dd>
                                </React.Fragment>
                            ))}
                        </dl>
                        {children}
                    </Popover.Body>
                </Popover>
            )}
        >
            <button
                type="button"
                aria-label={label}
                style={{ display: 'inline-flex', padding: 0, border: 0, background: 'none', color: '#9ca3af', cursor: 'default' }}
            >
                <Info size={14} />
            </button>
        </OverlayTrigger>
    );
}
